export class OrderRequestItem {
    quantity: number;
    remoteProductId: string | number; // Assuming product_id can be string or number
    source: string;
    productId: number;
    /**
     * Per-line resolution outcome.
     *
     * - `SUCCESS`    — resolved to a Product.
     * - `NO_PRODUCT` — could not be resolved and is not white-listed; the server
     *                  sets `productStatus = 'ERROR'` for the order.
     * - `WHITE_LIST` — unresolved but matched `EcommerceConnectionProductWhiteList`,
     *                  so the line is knowingly not printed.
     * - `IGNORE`     — the operator dismissed this line. It is carried through with
     *                  `quantity: 0` rather than deleted, so the audit copy still
     *                  shows what the remote order contained and the dismissal can
     *                  be undone. The server must skip it entirely: it produces no
     *                  print-node order item and must NOT hold the order in
     *                  `productStatus = 'ERROR'` even if it never resolved.
     * - `''`         — not yet evaluated.
     *
     * Only lines added manually in the UI are physically removed from `items[]`;
     * anything that arrived from the gateway or a CSV is preserved and marked.
     */
    status: 'SUCCESS' | 'NO_PRODUCT' | 'WHITE_LIST' | 'IGNORE' | '' = '';
}

export class OrderRequest {
    // Organization and connection details
    org_ID: number = 0;
    ecommerceConnectionId: number = 0;

    // Order identification
    orderId: string = ''; // Id of the remote ecommerce order

    // Financial details
    productsCharged: number = 0;
    shippingCharged: number = 0;
    taxCharged: number = 0;

    // Shipping and service details
    serviceLevel: string = '';
    rawShippingCode: string = '';

    // Shipping address details
    title: string = '';
    firstName: string = '';
    lastName: string = '';
    company: string = '';
    address1: string = '';
    address2: string = '';
    city: string = '';
    state: string = '';
    country: string = '';
    postalCode: string = '';
    phone: string = '';
    email: string = '';

    // Product matching status and items
    items: OrderRequestItem[] = [];

    // Optional properties, not explicitly assigned in the snippet but common in order requests
    couponCode?: string;
    purchaseOrder?: string;
    purchaseOrderPrivate?: string;


    constructor(initialData?: Partial<OrderRequest>) {
        if (initialData) {
            Object.assign(this, initialData);
        }
    }
}
